import React from "react";
import Header1 from "./Header1";
import Header2 from "./Header2";
import Formular from "./Formular";
import Body2 from "./Body2";
import Body6 from "./Body6";
import Footer1 from "./Footer1";
import Footer2 from "./Footer2";


function PageKontakt() {

  return (
    <div>
      <Header1/>
      <Header2/>
      <Body6/>
      <Formular/>
      <Body2/>
      <Footer1/>
      <Footer2/>
    </div>
  );
}

export default PageKontakt;
